
export const CREATING = 'CREATING';
export const CREATED = 'CREATED';
export const DESTROY = 'DESTROY';
